import * as actionTypes from "../actionTypes";
const initialState = {
  scenarios: [],
  quesAnw: {},
  savingResult: null,
  isLoading: false,
  error: null,
  interestedCareerSaved: false,
  showLoader: false,
  affilliateSuccess: false,
  affilliateError: false,
  affilliateLoading:false
};
const scenariosReducer = (state = initialState, { type, payload, error }) => {
  switch (type) {
    case actionTypes.GET_SCENARIOS:
      return {
        ...state,
        error:null,
        scenarios: [],
      };
    case actionTypes.GET_SCENARIOS_SUCCESS:
      return {
        ...state,
        savingResult: null,
        scenarios: payload,
      };
    case actionTypes.GET_SCENARIOS_ERROR:
      return {
        ...state,
        error: payload,
      };
    case actionTypes.GET_RECOMMENDATIONS_QUESTION:
      return {
        ...state,
        isLoading: true,
        quesAnw: {},
      };
    case actionTypes.GET_RECOMMENDATIONS_QUESTION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        quesAnw: {
          ...state.quesAnw,
          [payload.id]: payload, // Update specific answer by ID
        },
      };
    case actionTypes.GET_RECOMMENDATIONS_QUESTION_ERROR:
      return {
        ...state,
        isLoading: false,
        error: payload,
      };
    case actionTypes.SET_SCENARIOS:
      return {
        ...state,
        error:null,
        savingLoading: true,
        savingResult: null,
      };
    case actionTypes.SET_SCENARIOS_SUCCESS:
      return {
        ...state,
        error:null,
        savingResult: payload,
        savingLoading: false,
      };
    case actionTypes.SET_SCENARIOS_ERROR:
      return {
        ...state,
        savingResult: null,
        savingLoading: false,
      };
    case actionTypes.RESET_SAVING_RESULT:
      return {
        ...state,
        savingResult: null,
      };
    case actionTypes.GET_RESULTS:
      return {
        ...state,
        results: payload?.keepPrevious ? state.results : null,
        error: null,
        isLoading: true,
      };
    case actionTypes.GET_RESULTS_SUCCESS:
      return {
        ...state,
        results: payload,
        error:null,
        isLoading: false,
      };
    case actionTypes.GET_RESULTS_ERROR:
      return {
        ...state,
        error: error?.response?.status === 403 ? error?.response?.data : null,
        isLoading: false,
      };
    case actionTypes.GET_RESULTS_DETAIL:
      return {
        ...state,
        results_detail: null,
        error: null,
        isLoadingDetail: true,
      };
    case actionTypes.GET_RESULTS_DETAIL_SUCCESS:
      return {
        ...state,
        results_detail: payload,
        isLoadingDetail: false,
      };
    case actionTypes.GET_RESULTS_DETAIL_ERROR:
      return {
        ...state,
        error: error?.response?.status === 403 ? error?.response?.data : null,
        isLoadingDetail: false,
      };
    case actionTypes.SET_RESULTS:
      return {
        ...state,
        isSetResultsSuccessLoaded: false,
      };
    case actionTypes.SET_RESULTS_SUCCESS:
      return {
        ...state,
        isSetResultsSuccessLoaded: true,
      };
    case actionTypes.SET_RESULTS_ERROR:
      return {
        ...state,
        isSetResultsSuccessLoaded: true,
      };
    case actionTypes.CHECK_AFFILIATE:
      return {
        ...state,
        affilliateError: false,
        affilliateSuccess: false,
        affilliateLoading: true,
      };
    case actionTypes.CHECK_AFFILIATE_SUCCESS:
      return {
        ...state,
        affilliateLoading: false,
        affilliateSuccess: true,
      };
    case actionTypes.CHECK_AFFILIATE_ERROR:
      return {
        ...state,
        affilliateLoading: false,
        affilliateError: true,
      };
    case actionTypes.CLEAR_STATE_AFFILIATE:
      return {
        ...state,
        affilliateSuccess: false,
        affilliateLoading: false,
        affilliateError: false,
      };
    case actionTypes.INIT_INTERESTED_CAREER:
      return {
        ...state,
        interestedCareerSaved: false,
        showLoader: true,
      };
    case actionTypes.INTERESTED_CAREER:
      return {
        ...state,
        interestedCareerSaved: false,
      };
    case actionTypes.INTERESTED_CAREER_SUCCESS:
      return {
        ...state,
        results_detail: payload,
        interestedCareerSaved: true,
        showLoader: false,
        results: state.results?.map((item) =>
          item.id === payload.id
            ? {
                ...item,
                interested: payload.interested,
                sort_decision: payload.sort_decision ?? item.sort_decision,
              }
            : item,
        ),
      };
    case actionTypes.INTERESTED_CAREER_ERROR:
      return {
        ...state,
        interestedCareerSaved: false,
        showLoader: false,
      };

    default:
      return state;
  }
};
export default scenariosReducer;
